import { BorderRadius, Colors, MediaMediumAndAbove, Spacing } from '@lichtblick/theme';
import { Text } from '@lichtblick/ui-components';
import styled from 'styled-components';
import { getColor } from '../../../../utils';
export const Rows = styled.div`
  background: ${({ $backgroundColor })=>$backgroundColor || 'transparent'};
  border-radius: ${BorderRadius.S};
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3Xs']};
  padding: ${Spacing.S};
  width: 100%;
`;
export const Row = styled.div`
  display: flex;
  gap: ${Spacing.Xxs};
  overflow: auto;
  position: relative;
`;
export const SecondRow = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: auto;
  position: relative;
`;
export const Label = styled(Text)`
  z-index: 1;
`;
export const Divider = styled.span`
  align-self: stretch;
  background-image: linear-gradient(to right, ${Colors.Gray} 1px, ${Colors.FadedMoss} 1px);
  background-position: top;
  background-repeat: repeat-x;
  background-size: ${Spacing['3Xs']} 1px;
  content: '';
  flex: 1;
  height: 1px;
  margin-top: 0.875rem;
  width: 100%;
  z-index: 0;

  ${MediaMediumAndAbove} {
    margin-top: 1rem;
  }
`;
export const Value = styled(Text)`
  color: ${({ $color = 'black' })=>getColor($color)};
  text-align: right;
  z-index: 1;
`;

//# sourceMappingURL=Listing.styles.js.map